import React from 'react';
const SocialGuide: React.FC = () => (
  <div className="min-h-screen bg-white py-12" dir="ltr">
    <div className="max-w-3xl mx-auto bg-indigo-50 rounded-xl shadow-lg p-8">
      <h1 className="text-3xl font-bold text-indigo-900 mb-6">Social Etiquette in Iran</h1>
      <p className="text-lg text-gray-700 mb-4">Understand ta'arof, introductions, and what topics to avoid in conversation.</p>
      {/* Add more content here */}
    </div>
  </div>
);
export default SocialGuide; 